export const SunIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M10 14.5C8.80653 14.5 7.66193 14.0259 6.81802 13.182C5.97411 12.3381 5.5 11.1935 5.5 10C5.5 8.80653 5.97411 7.66193 6.81802 6.81802C7.66193 5.97411 8.80653 5.5 10 5.5C11.1935 5.5 12.3381 5.97411 13.182 6.81802C14.0259 7.66193 14.5 8.80653 14.5 10C14.5 11.1935 14.0259 12.3381 13.182 13.182C12.3381 14.0259 11.1935 14.5 10 14.5ZM9.25 1.75H10.75V4H9.25V1.75ZM9.25 16H10.75V18.25H9.25V16ZM3.63625 4.69675L4.69675 3.63625L6.2875 5.227L5.227 6.2875L3.63625 4.6975V4.69675ZM13.7125 14.773L14.773 13.7125L16.3638 15.3032L15.3032 16.3638L13.7125 14.773ZM15.3032 3.6355L16.3638 4.69675L14.773 6.2875L13.7125 5.227L15.3032 3.63625V3.6355ZM5.227 13.7125L6.2875 14.773L4.69675 16.3638L3.63625 15.3032L5.227 13.7125ZM18.25 9.25V10.75H16V9.25H18.25ZM4 9.25V10.75H1.75V9.25H4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MoonIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M8.5 6.25C8.49985 7.29298 8.81035 8.31237 9.39192 9.17816C9.97348 10.0439 10.7997 10.7169 11.7653 11.1112C12.7309 11.5055 13.7921 11.6032 14.8134 11.3919C15.8348 11.1807 16.7701 10.67 17.5 9.925V10C17.5 14.1423 14.1423 17.5 10 17.5C5.85775 17.5 2.5 14.1423 2.5 10C2.5 5.85775 5.85775 2.5 10 2.5H10.075C9.57553 2.98834 9.17886 3.57172 8.90836 4.21576C8.63786 4.8598 8.49902 5.55146 8.5 6.25ZM4 10C3.99945 11.3387 4.44665 12.6392 5.27042 13.6945C6.09419 14.7497 7.24723 15.4992 8.54606 15.8236C9.84489 16.148 11.2149 16.0287 12.4381 15.4847C13.6614 14.9407 14.6675 14.0033 15.2965 12.8215C14.1771 13.0852 13.0088 13.0586 11.9026 12.744C10.7964 12.4295 9.78888 11.8376 8.97566 11.0243C8.16244 10.2111 7.57048 9.20361 7.25596 8.09738C6.94144 6.99116 6.91477 5.82292 7.1785 4.7035C6.21818 5.2151 5.41509 5.97825 4.85519 6.91123C4.2953 7.84422 3.99968 8.91191 4 10Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DownArrow = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M13.5 6.41L12.09 5L7.5 9.58L2.91 5L1.5 6.41L7.5 12.41L13.5 6.41Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const NotificationIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M19.2 16.5H21V18.3H3V16.5H4.8V10.2C4.8 8.29044 5.55857 6.45909 6.90883 5.10883C8.25909 3.75857 10.0904 3 12 3C13.9096 3 15.7409 3.75857 17.0912 5.10883C18.4414 6.45909 19.2 8.29044 19.2 10.2V16.5ZM17.4 16.5V10.2C17.4 8.76783 16.8311 7.39432 15.8184 6.38162C14.8057 5.36893 13.4322 4.8 12 4.8C10.5678 4.8 9.19432 5.36893 8.18162 6.38162C7.16893 7.39432 6.6 8.76783 6.6 10.2V16.5H17.4ZM9.3 20.1H14.7V21.9H9.3V20.1Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UsersIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={12}
      viewBox="0 0 16 12"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M0 9.9C0 9.475 0.106061 9.08437 0.318182 8.72812C0.530303 8.37187 0.812121 8.1 1.16364 7.9125C1.91515 7.525 2.67879 7.23438 3.45455 7.04062C4.2303 6.84687 5.01818 6.75 5.81818 6.75C6.61818 6.75 7.40606 6.84687 8.18182 7.04062C8.95758 7.23438 9.72121 7.525 10.4727 7.9125C10.8242 8.1 11.1061 8.37187 11.3182 8.72812C11.5303 9.08437 11.6364 9.475 11.6364 9.9V10.5C11.6364 10.9125 11.4939 11.2656 11.2091 11.5594C10.9242 11.8531 10.5818 12 10.1818 12H1.45455C1.05455 12 0.712121 11.8531 0.427273 11.5594C0.142424 11.2656 0 10.9125 0 10.5V9.9ZM14.5455 12H12.6909C12.8242 11.775 12.9242 11.5344 12.9909 11.2781C13.0576 11.0219 13.0909 10.7625 13.0909 10.5V9.75C13.0909 9.2 12.9424 8.67188 12.6455 8.16562C12.3485 7.65937 11.9273 7.225 11.3818 6.8625C12 6.9375 12.5818 7.06563 13.1273 7.24688C13.6727 7.42813 14.1818 7.65 14.6545 7.9125C15.0909 8.1625 15.4242 8.44063 15.6545 8.74688C15.8848 9.05313 16 9.3875 16 9.75V10.5C16 10.9125 15.8576 11.2656 15.5727 11.5594C15.2879 11.8531 14.9455 12 14.5455 12ZM5.81818 6C5.01818 6 4.33333 5.70625 3.76364 5.11875C3.19394 4.53125 2.90909 3.825 2.90909 3C2.90909 2.175 3.19394 1.46875 3.76364 0.88125C4.33333 0.29375 5.01818 0 5.81818 0C6.61818 0 7.30303 0.29375 7.87273 0.88125C8.44242 1.46875 8.72727 2.175 8.72727 3C8.72727 3.825 8.44242 4.53125 7.87273 5.11875C7.30303 5.70625 6.61818 6 5.81818 6ZM13.0909 3C13.0909 3.825 12.8061 4.53125 12.2364 5.11875C11.6667 5.70625 10.9818 6 10.1818 6C10.0485 6 9.87879 5.98438 9.67273 5.95312C9.46667 5.92188 9.29697 5.8875 9.16364 5.85C9.49091 5.45 9.74242 5.00625 9.91818 4.51875C10.0939 4.03125 10.1818 3.525 10.1818 3C10.1818 2.475 10.0939 1.96875 9.91818 1.48125C9.74242 0.99375 9.49091 0.55 9.16364 0.15C9.33333 0.0875 9.50303 0.046875 9.67273 0.028125C9.84242 0.009375 10.0121 0 10.1818 0C10.9818 0 11.6667 0.29375 12.2364 0.88125C12.8061 1.46875 13.0909 2.175 13.0909 3ZM1.45455 10.5H10.1818V9.9C10.1818 9.7625 10.1485 9.6375 10.0818 9.525C10.0152 9.4125 9.92727 9.325 9.81818 9.2625C9.16364 8.925 8.50303 8.67188 7.83636 8.50313C7.1697 8.33438 6.49697 8.25 5.81818 8.25C5.13939 8.25 4.46667 8.33438 3.8 8.50313C3.13333 8.67188 2.47273 8.925 1.81818 9.2625C1.70909 9.325 1.62121 9.4125 1.55455 9.525C1.48788 9.6375 1.45455 9.7625 1.45455 9.9V10.5ZM5.81818 4.5C6.21818 4.5 6.56061 4.35313 6.84546 4.05937C7.1303 3.76562 7.27273 3.4125 7.27273 3C7.27273 2.5875 7.1303 2.23438 6.84546 1.94063C6.56061 1.64688 6.21818 1.5 5.81818 1.5C5.41818 1.5 5.07576 1.64688 4.79091 1.94063C4.50606 2.23438 4.36364 2.5875 4.36364 3C4.36364 3.4125 4.50606 3.76562 4.79091 4.05937C5.07576 4.35313 5.41818 4.5 5.81818 4.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SettingIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M7.74347 3.23798C8.06327 1.92067 9.93673 1.92067 10.2565 3.23798C10.4631 4.08895 11.4381 4.49278 12.1859 4.03714C13.3435 3.33179 14.6682 4.65653 13.9629 5.81414C13.5072 6.56194 13.9111 7.53688 14.762 7.74347C16.0793 8.06327 16.0793 9.93673 14.762 10.2565C13.9111 10.4631 13.5072 11.4381 13.9629 12.1859C14.6682 13.3435 13.3435 14.6682 12.1859 13.9629C11.4381 13.5072 10.4631 13.9111 10.2565 14.762C9.93673 16.0793 8.06327 16.0793 7.74347 14.762C7.53688 13.9111 6.56194 13.5072 5.81414 13.9629C4.65653 14.6682 3.33179 13.3435 4.03714 12.1859C4.49278 11.4381 4.08895 10.4631 3.23798 10.2565C1.92067 9.93673 1.92067 8.06327 3.23798 7.74347C4.08895 7.53688 4.49278 6.56194 4.03714 5.81414C3.33179 4.65653 4.65653 3.33179 5.81414 4.03714C6.56194 4.49278 7.53688 4.08895 7.74347 3.23798Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 9C11.25 10.2426 10.2426 11.25 9 11.25C7.75736 11.25 6.75 10.2426 6.75 9C6.75 7.75736 7.75736 6.75 9 6.75C10.2426 6.75 11.25 7.75736 11.25 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LogoutIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M6.75 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H6.75M12 12.75L15.75 9M15.75 9L12 5.25M15.75 9H6.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ContactIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17}
      height={16}
      viewBox="0 0 17 16"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M5.59799 3.9602H14.9796L9.85479 7.9846C9.75189 8.06329 9.62881 8.11121 9.49979 8.1228C9.3701 8.11098 9.2463 8.06311 9.14239 7.9846L5.47999 5.1076C5.44124 5.07621 5.39684 5.05252 5.34919 5.0378C5.5269 4.78877 5.62 4.48929 5.61479 4.1834C5.61325 4.10875 5.60764 4.03424 5.59799 3.9602ZM3.21219 1.372C3.22399 1.374 3.24339 1.3814 3.28559 1.401C3.36899 1.4406 3.50159 1.5426 3.63139 1.6848C3.89279 1.9696 4.15399 2.401 4.28959 2.6858C4.29379 2.6942 4.29819 2.7034 4.30219 2.7128C4.68699 3.373 4.85299 3.878 4.85799 4.1948C4.86339 4.513 4.77799 4.65 4.50819 4.805L3.81219 5.2062C3.35879 5.4672 3.14459 5.935 3.09139 6.3714C3.03799 6.808 3.11659 7.2322 3.31079 7.5676L5.02879 10.5286C5.22339 10.8638 5.55559 11.1442 5.96179 11.3164C6.36839 11.489 6.88259 11.5378 7.33599 11.2774L8.03199 10.877C8.30159 10.7224 8.46459 10.7192 8.73839 10.882C9.01299 11.0452 9.36959 11.4394 9.75279 12.1C9.75819 12.1098 9.76339 12.118 9.76959 12.1274C9.94919 12.3864 10.1938 12.8258 10.3118 13.1938C10.3704 13.3766 10.3934 13.5418 10.386 13.6332C10.3778 13.725 10.3758 13.7156 10.3516 13.73L9.82199 14.0336C8.49159 14.6106 7.27219 14.4804 6.18239 13.9152C5.09059 13.3476 4.14159 12.3226 3.47999 11.1192C3.47779 11.1168 3.47679 11.1138 3.47499 11.1122L2.02579 8.6146C2.02339 8.6122 2.02239 8.61 2.02039 8.6068C1.30339 7.4348 0.885591 6.1042 0.937991 4.88C0.990391 3.6576 1.48639 2.5432 2.65479 1.6858L3.18459 1.3832C3.19679 1.3762 3.20079 1.3708 3.21219 1.372ZM3.21759 0.6278C3.07739 0.6256 2.93439 0.655 2.80579 0.7296L2.24559 1.0518C2.23299 1.059 2.22139 1.0664 2.20999 1.0736C0.862191 2.06 0.241591 3.4332 0.180991 4.8486C0.120391 6.2634 0.592791 7.7236 1.37319 9.0002L2.81759 11.4892L2.81419 11.4818C3.53519 12.792 4.56839 13.9286 5.83099 14.5834C7.09419 15.2392 8.59899 15.3912 10.1318 14.7228C10.1444 14.7174 10.1572 14.7114 10.1686 14.7044L10.7296 14.3822C10.989 14.2346 11.1194 13.9474 11.1406 13.6966C11.1624 13.4466 11.1114 13.2032 11.034 12.9634C10.8824 12.4892 10.618 12.0286 10.3996 11.7126C9.98699 11.0028 9.58859 10.5102 9.12819 10.2348C8.90578 10.1011 8.65156 10.0294 8.39205 10.0274C8.13254 10.0254 7.87724 10.0931 7.65279 10.2234L6.95679 10.6246C6.75119 10.743 6.51079 10.7292 6.25779 10.6222C6.00599 10.5152 5.77279 10.3012 5.68619 10.1512L3.96819 7.1904C3.88139 7.0396 3.81039 6.732 3.84399 6.4608C3.87639 6.1904 3.98619 5.9786 4.19199 5.86L4.86819 5.4712C4.88579 5.5618 4.93699 5.644 5.01119 5.6992L8.67379 8.5768C8.90425 8.75918 9.18505 8.8666 9.47839 8.8846C9.49298 8.8854 9.5076 8.8854 9.52219 8.8846C9.81521 8.8665 10.0957 8.75908 10.3258 8.5768L15.3702 4.614V11.1608C15.3702 11.2604 15.2566 11.3916 15.0338 11.3916H11.5416C11.4918 11.3913 11.4424 11.4008 11.3963 11.4196C11.3502 11.4384 11.3083 11.4661 11.2729 11.5012C11.2376 11.5363 11.2095 11.578 11.1903 11.6239C11.1711 11.6699 11.1612 11.7192 11.1612 11.769C11.1612 11.9776 11.3316 12.1472 11.5416 12.146H15.0338C15.6046 12.146 16.1292 11.7334 16.1292 11.1608V4.191C16.1292 3.618 15.6046 3.2056 15.0338 3.2056H5.39019C5.28339 2.9386 5.14239 2.6556 4.96479 2.348C4.79859 2.002 4.52899 1.5446 4.19159 1.1768C4.02119 0.9904 3.83739 0.8252 3.60759 0.7184V0.7194C3.48535 0.662139 3.35254 0.630945 3.21759 0.6278Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
    </svg>
  );
};

export const AskAiIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_640_12670)">
        <path
          d="M14.4268 2.42666L13.5734 1.57332C13.4984 1.49753 13.4091 1.43737 13.3107 1.39631C13.2123 1.35525 13.1067 1.33411 13.0001 1.33411C12.8935 1.33411 12.7879 1.35525 12.6895 1.39631C12.5911 1.43737 12.5018 1.49753 12.4268 1.57332L1.57344 12.4267C1.49766 12.5017 1.43749 12.591 1.39643 12.6894C1.35537 12.7878 1.33423 12.8934 1.33423 13C1.33423 13.1066 1.35537 13.2122 1.39643 13.3106C1.43749 13.409 1.49766 13.4983 1.57344 13.5733L2.42678 14.4267C2.50133 14.5033 2.59047 14.5642 2.68894 14.6057C2.78741 14.6473 2.89322 14.6687 3.00011 14.6687C3.107 14.6687 3.21281 14.6473 3.31128 14.6057C3.40975 14.5642 3.4989 14.5033 3.57344 14.4267L14.4268 3.57332C14.5034 3.49878 14.5643 3.40963 14.6058 3.31116C14.6474 3.21269 14.6688 3.10688 14.6688 2.99999C14.6688 2.8931 14.6474 2.78729 14.6058 2.68882C14.5643 2.59035 14.5034 2.5012 14.4268 2.42666Z"
          stroke="url(#paint0_linear_640_12670)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33325 4.66669L11.3333 6.66669"
          stroke="url(#paint1_linear_640_12670)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33325 4V6.66667"
          stroke="url(#paint2_linear_640_12670)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6667 9.33331V12"
          stroke="url(#paint3_linear_640_12670)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66675 1.33331V2.66665"
          stroke="url(#paint4_linear_640_12670)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66667 5.33331H2"
          stroke="url(#paint5_linear_640_12670)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9999 10.6667H11.3333"
          stroke="url(#paint6_linear_640_12670)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33333 2H6"
          stroke="url(#paint7_linear_640_12670)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_640_12670"
          x1="1.33423"
          y1="8.00142"
          x2="14.1004"
          y2="8.00142"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E375D1" />
          <stop offset="0.837708" stopColor="#8370F8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_640_12670"
          x1="9.33325"
          y1="5.66669"
          x2="11.248"
          y2="5.66669"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E375D1" />
          <stop offset="0.837708" stopColor="#8370F8" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_640_12670"
          x1="3.33325"
          y1="5.33333"
          x2="4.29062"
          y2="5.33333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E375D1" />
          <stop offset="0.837708" stopColor="#8370F8" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_640_12670"
          x1="12.6667"
          y1="10.6666"
          x2="13.6241"
          y2="10.6666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E375D1" />
          <stop offset="0.837708" stopColor="#8370F8" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_640_12670"
          x1="6.66675"
          y1="1.99998"
          x2="7.62412"
          y2="1.99998"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E375D1" />
          <stop offset="0.837708" stopColor="#8370F8" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_640_12670"
          x1={2}
          y1="5.83331"
          x2="4.55299"
          y2="5.83331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E375D1" />
          <stop offset="0.837708" stopColor="#8370F8" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_640_12670"
          x1="11.3333"
          y1="11.1667"
          x2="13.8862"
          y2="11.1667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E375D1" />
          <stop offset="0.837708" stopColor="#8370F8" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_640_12670"
          x1={6}
          y1="2.5"
          x2="7.27649"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E375D1" />
          <stop offset="0.837708" stopColor="#8370F8" />
        </linearGradient>
        <clipPath id="clip0_640_12670">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ClockIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <mask
        id="mask0_701_7560"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="currentColor" />
      </mask>
      <g mask="url(#mask0_701_7560)">
        <path
          d="M11.9808 20.5C9.81544 20.5 7.92828 19.7872 6.31928 18.3615C4.71028 16.9358 3.78403 15.1487 3.54053 13H5.07128C5.32378 14.727 6.10103 16.1587 7.40303 17.2952C8.70486 18.4318 10.2308 19 11.9808 19C13.9308 19 15.5849 18.3208 16.9433 16.9625C18.3016 15.6042 18.9808 13.95 18.9808 12C18.9808 10.05 18.3016 8.39583 16.9433 7.0375C15.5849 5.67917 13.9308 5 11.9808 5C10.8884 5 9.86478 5.24267 8.90978 5.728C7.95461 6.21317 7.13211 6.88075 6.44228 7.73075H9.05778V9.23075H3.98078V4.15375H5.48078V6.523C6.29228 5.56533 7.26411 4.82208 8.39628 4.29325C9.52828 3.76442 10.7231 3.5 11.9808 3.5C13.1603 3.5 14.2654 3.72308 15.2963 4.16925C16.3269 4.61542 17.2256 5.22183 17.9923 5.9885C18.7589 6.75517 19.3654 7.65392 19.8115 8.68475C20.2577 9.71542 20.4808 10.8205 20.4808 12C20.4808 13.1795 20.2577 14.2846 19.8115 15.3152C19.3654 16.3461 18.7589 17.2448 17.9923 18.0115C17.2256 18.7782 16.3269 19.3846 15.2963 19.8307C14.2654 20.2769 13.1603 20.5 11.9808 20.5ZM14.9828 16.027L11.2598 12.3038V7H12.7595V11.6962L16.0365 14.973L14.9828 16.027Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const FilterIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <mask
        id="mask0_701_7571"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="currentColor" />
      </mask>
      <g mask="url(#mask0_701_7571)">
        <path
          d="M17.6538 19.6537C16.7169 19.6537 15.925 19.3303 15.278 18.6834C14.6312 18.0364 14.3077 17.2445 14.3077 16.3077C14.3077 15.3707 14.6312 14.5788 15.278 13.9319C15.925 13.2849 16.7169 12.9614 17.6538 12.9614C18.5908 12.9614 19.3827 13.2849 20.0295 13.9319C20.6765 14.5788 21 15.3707 21 16.3077C21 17.2445 20.6765 18.0364 20.0295 18.6834C19.3827 19.3303 18.5908 19.6537 17.6538 19.6537ZM17.6528 18.1537C18.1624 18.1537 18.5977 17.9736 18.9587 17.6134C19.3196 17.2531 19.5 16.8182 19.5 16.3087C19.5 15.799 19.3198 15.3637 18.9595 15.0027C18.5993 14.6419 18.1644 14.4614 17.6547 14.4614C17.1451 14.4614 16.7098 14.6416 16.349 15.0019C15.9882 15.3621 15.8077 15.797 15.8077 16.3067C15.8077 16.8164 15.9878 17.2516 16.348 17.6124C16.7083 17.9733 17.1433 18.1537 17.6528 18.1537ZM4.5 17.0577V15.5577H12.1155V17.0577H4.5ZM6.34625 11.0384C5.40925 11.0384 4.61733 10.7149 3.9705 10.0679C3.3235 9.42111 3 8.62919 3 7.69219C3 6.75536 3.3235 5.96344 3.9705 5.31644C4.61733 4.66961 5.40925 4.34619 6.34625 4.34619C7.28308 4.34619 8.075 4.66961 8.722 5.31644C9.36883 5.96344 9.69225 6.75536 9.69225 7.69219C9.69225 8.62919 9.36883 9.42111 8.722 10.0679C8.075 10.7149 7.28308 11.0384 6.34625 11.0384ZM6.34525 9.53844C6.85492 9.53844 7.29017 9.35827 7.651 8.99794C8.01183 8.63777 8.19225 8.20286 8.19225 7.69319C8.19225 7.18352 8.01217 6.74828 7.652 6.38744C7.29167 6.02661 6.85675 5.84619 6.34725 5.84619C5.83758 5.84619 5.40225 6.02628 5.04125 6.38644C4.68042 6.74678 4.5 7.18169 4.5 7.69119C4.5 8.20086 4.68017 8.63619 5.0405 8.99719C5.40067 9.35803 5.83558 9.53844 6.34525 9.53844ZM11.8845 8.44219V6.94219H19.5V8.44219H11.8845Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const PencilIcon = ({ className, ...props }) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g id="edit">
        <path
          id="icon"
          d="M3.33333 12.6667H4.28333L10.8 6.15L9.85 5.2L3.33333 11.7167V12.6667ZM2 14V11.1667L10.8 2.38333C10.9333 2.26111 11.0806 2.16667 11.2417 2.1C11.4028 2.03333 11.5722 2 11.75 2C11.9278 2 12.1 2.03333 12.2667 2.1C12.4333 2.16667 12.5778 2.26667 12.7 2.4L13.6167 3.33333C13.75 3.45556 13.8472 3.6 13.9083 3.76667C13.9694 3.93333 14 4.1 14 4.26667C14 4.44444 13.9694 4.61389 13.9083 4.775C13.8472 4.93611 13.75 5.08333 13.6167 5.21667L4.83333 14H2ZM10.3167 5.68333L9.85 5.2L10.8 6.15L10.3167 5.68333Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const WarnRedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M16.9654 14.0703V6.92956C16.9655 6.79242 16.9294 6.6577 16.8608 6.53894C16.7922 6.42017 16.6936 6.32155 16.5748 6.25299L10.3907 2.68252C10.2719 2.61397 10.1372 2.57788 10.0001 2.57788C9.86292 2.57788 9.7282 2.61397 9.60943 2.68252L3.42529 6.25291C3.30653 6.32148 3.20791 6.4201 3.13934 6.53886C3.07077 6.65762 3.03467 6.79234 3.03467 6.92948V14.0703C3.03466 14.2075 3.07076 14.3422 3.13933 14.461C3.2079 14.5797 3.30653 14.6783 3.42529 14.7469L9.60943 18.3174C9.7282 18.3859 9.86292 18.422 10.0001 18.422C10.1372 18.422 10.2719 18.3859 10.3907 18.3174L16.5748 14.747C16.8165 14.6074 16.9654 14.3495 16.9654 14.0703Z"
        fill="#E63950"
      />
      <path
        d="M15.3132 13.2235V7.77634C15.3132 7.67173 15.2857 7.56897 15.2334 7.47837C15.1811 7.38778 15.1059 7.31255 15.0153 7.26025L10.2979 4.53665C10.2073 4.48433 10.1045 4.45679 9.99988 4.45679C9.89527 4.45679 9.7925 4.48433 9.70191 4.53665L4.98449 7.26025C4.8939 7.31256 4.81868 7.38779 4.76638 7.47838C4.71407 7.56897 4.68653 7.67173 4.68652 7.77634V13.2235C4.68652 13.3281 4.71406 13.4309 4.76636 13.5215C4.81867 13.6121 4.8939 13.6873 4.98449 13.7396L9.70191 16.4632C9.7925 16.5155 9.89527 16.5431 9.99988 16.5431C10.1045 16.5431 10.2073 16.5155 10.2979 16.4632L15.0153 13.7396C15.1059 13.6873 15.1811 13.6121 15.2334 13.5215C15.2857 13.4309 15.3132 13.3281 15.3132 13.2235Z"
        fill="#B7022D"
      />
      <path
        d="M3.50293 13.7741C3.41699 13.7741 3.34668 13.7038 3.34668 13.6178V6.92957C3.34714 6.84733 3.36898 6.76664 3.41008 6.69541C3.45117 6.62418 3.51009 6.56487 3.58105 6.52332L9.76543 2.953C9.9084 2.87097 10.092 2.87097 10.2342 2.953L13.2521 4.69605C13.2881 4.71636 13.3146 4.74988 13.3248 4.79058C13.3357 4.83121 13.3303 4.87339 13.3092 4.90933C13.2678 4.98043 13.1686 5.00785 13.0959 4.96636L10.0779 3.22324C10.0311 3.19667 9.96855 3.19667 9.92168 3.22324L3.7373 6.79433C3.68965 6.82175 3.65918 6.8748 3.65918 6.92949V13.6178C3.65918 13.6593 3.64272 13.699 3.61342 13.7283C3.58411 13.7576 3.54437 13.7741 3.50293 13.7741ZM13.7154 5.2998C13.6881 5.2998 13.6607 5.29199 13.6373 5.27871C13.6014 5.25753 13.5756 5.22402 13.5646 5.18417C13.5592 5.16433 13.5577 5.14359 13.5604 5.12318C13.5631 5.10277 13.5699 5.0831 13.5803 5.06535C13.6217 4.99347 13.7217 4.96613 13.7936 5.00839C13.8678 5.05136 13.8936 5.14667 13.8506 5.2216C13.8368 5.24529 13.8171 5.26498 13.7934 5.2787C13.7697 5.29242 13.7428 5.29969 13.7154 5.2998Z"
        fill="#E8566F"
      />
      <path
        d="M16.5748 6.2529L16.1725 6.02063C16.1794 6.0625 16.1842 6.10501 16.1842 6.14829V13.2891C16.1842 13.4263 16.1481 13.561 16.0795 13.6798C16.011 13.7985 15.9123 13.8971 15.7936 13.9657L9.60943 17.5361C9.49066 17.6047 9.35594 17.6407 9.21881 17.6407C9.08167 17.6407 8.94695 17.6047 8.82818 17.5361L3.04639 14.198C3.06507 14.3118 3.10874 14.42 3.17426 14.515C3.23977 14.6099 3.3255 14.6891 3.42529 14.747L9.60943 18.3173C9.7282 18.3859 9.86292 18.422 10.0001 18.422C10.1372 18.422 10.2719 18.3859 10.3907 18.3173L16.5748 14.747C16.6936 14.6784 16.7922 14.5798 16.8608 14.461C16.9293 14.3422 16.9654 14.2075 16.9654 14.0704V6.92954C16.9654 6.6504 16.8165 6.3925 16.5748 6.2529Z"
        fill="#D10028"
      />
      <path
        d="M16.575 6.2529L16.5009 6.21008C16.5481 6.31165 16.575 6.42305 16.575 6.53883V13.6797C16.575 13.8168 16.5389 13.9515 16.4703 14.0703C16.4017 14.1891 16.3031 14.2877 16.1844 14.3563L10.0002 17.9267C9.88144 17.9953 9.74672 18.0314 9.60959 18.0314C9.47245 18.0314 9.33773 17.9953 9.21896 17.9267L3.10889 14.3991C3.17608 14.5448 3.28663 14.6663 3.42545 14.7469L9.60959 18.3173C9.72836 18.3859 9.86308 18.422 10.0002 18.422C10.1373 18.422 10.2721 18.3859 10.3908 18.3173L16.575 14.747C16.6937 14.6784 16.7924 14.5798 16.8609 14.461C16.9295 14.3422 16.9656 14.2075 16.9656 14.0704V6.92954C16.9656 6.6504 16.8167 6.39251 16.575 6.2529Z"
        fill="#B7022D"
      />
      <path
        d="M9.99998 11.5282C9.46686 11.5282 9.03467 11.096 9.03467 10.5629V7.31126C9.03467 6.77813 9.46686 6.34595 9.99998 6.34595C10.5331 6.34595 10.9653 6.77813 10.9653 7.31126V10.5629C10.9653 11.096 10.5331 11.5282 9.99998 11.5282ZM9.99998 14.6538C9.46686 14.6538 9.03467 14.2216 9.03467 13.6884C9.03467 13.1553 9.46686 12.7231 9.99998 12.7231C10.5331 12.7231 10.9653 13.1553 10.9653 13.6884C10.9653 14.2216 10.5331 14.6538 9.99998 14.6538Z"
        fill="white"
      />
    </svg>
  );
};

export const InfoIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M9.75 12.5H9V9.5H8.25M9 6.5H9.0075M15.75 9.5C15.75 13.2279 12.7279 16.25 9 16.25C5.27208 16.25 2.25 13.2279 2.25 9.5C2.25 5.77208 5.27208 2.75 9 2.75C12.7279 2.75 15.75 5.77208 15.75 9.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MenuIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={12}
      viewBox="0 0 18 12"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M2 6C2 6.55228 1.55228 7 1 7C0.447715 7 0 6.55228 0 6C0 5.44772 0.447715 5 1 5C1.55228 5 2 5.44772 2 6Z"
        fill="currentColor"
      />
      <path
        d="M4 5.94C4 5.42085 4.42085 5 4.94 5H17.06C17.5791 5 18 5.42085 18 5.94V6.06C18 6.57915 17.5791 7 17.06 7H4.94C4.42085 7 4 6.57915 4 6.06V5.94Z"
        fill="currentColor"
      />
      <path
        d="M0 10.94C0 10.4209 0.420852 10 0.94 10H17.06C17.5791 10 18 10.4209 18 10.94V11.06C18 11.5791 17.5791 12 17.06 12H0.940001C0.420853 12 0 11.5791 0 11.06V10.94Z"
        fill="currentColor"
      />
      <path
        d="M0 0.94C0 0.420852 0.420852 0 0.94 0H17.06C17.5791 0 18 0.420852 18 0.94V1.06C18 1.57915 17.5791 2 17.06 2H0.940001C0.420853 2 0 1.57915 0 1.06V0.94Z"
        fill="currentColor"
      />
    </svg>
  );
};
